import { Gender } from 'common/enum/gender'
import moment from 'moment-timezone'
import * as yup from 'yup'
import 'main/config/yup'

interface UpdatePatientData {
  patient_id: number
  name?: string
  socialName?: string
  gender?: Gender
  birthday?: string
  rg?: string
  cpf?: string
  email?: string
  phone?: string
  landlinePhone?: string
}

export interface AmbulatoryScheduleDetailsEditFormikValues {
  updatePatient: UpdatePatientData
  isEditing: boolean
}

export const ambulatoryScheduleDetailsValidationSchema = yup.object().shape({
  updatePatient: yup.object().shape({
    patient_id: yup.number().required(),
    name: yup.string().required(),
    birthday: yup
      .date()
      .format('DD/MM/YYYY', true)
      .required()
      .typeError('Data inválida')
      .test('lesser_then_today', 'Insira uma data válida.', (value) => {
        if (value) {
          const date = moment(value, 'DD/MM/YYYY').startOf('day')
          const now = moment().startOf('day')
          if (date.isValid()) {
            return date <= now
          }
        }
        return true
      }),
    gender: yup.string().required(),
    email: yup.string().email().required(),
    phone: yup
      .string()
      .transform((value) => value.replace(/\D/g, '')) // remove máscara
      .matches(
        /^\d{4}9\d{8}$/,
        'O telefone deve estar no formato correto com DDI + DDD + número iniciando com 9'
      )
      .required()
  }),
  isEditing: yup.boolean().nullable().optional()
})
